import axios from "axios"
import {
  parse
} from "qs"

const privateKey = '7212086462266e3dd06d49cf4f27c3a0cc585e9e9be0cb7ff1f7868c97ad657d'
const publicKey = '047509999627390cb472b46804d91b8a14b5426b47a2efd98f8af9439c907b4c5d446649ad8e4327f974c8fcfde58fda622716c386e48a42b7d2327e9395bd8bdb'

const ajax = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    'Accept': 'application/json'
  }
})

ajax.interceptors.request.use(
  config => {
    config.data = {
      appId: $grsc.appId,
      ...config.data
    }
    console.log(config.data)
    if (process.env.NODE_ENV === 'production') {
      const query = parse(config.data)
      const wasm_config = DgovCryptoWasm.encrypt_request(
        privateKey,
        publicKey,
        config.method,
        query || {}, {}
      )
      const {
        envelope,
        timestamp,
        nonce,
        signature,
        dgov_enc,
      } = JSON.parse(wasm_config)
      config.headers['dgov-req-appcode'] = nonce
      config.headers['dgov-req-envelope'] = envelope
      config.headers['dgov-req-timestamp'] = timestamp
      config.headers['dgov-req-nonce'] = nonce
      config.headers['dgov-req-signature'] = signature
      config.data = 'dgov_enc=' + encodeURIComponent(dgov_enc)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

ajax.interceptors.response.use(
  response => {
    if (
      process.env.NODE_ENV === 'production' &&
      response.data &&
      response.data.data &&
      response.data.data.dgov_enc &&
      response.data.data.dgov_key &&
      response.data.data.dgov_verify
    ) {
      const res = DgovCryptoWasm.decrypt_response(
        privateKey,
        publicKey,
        response.data.data.dgov_enc,
        response.data.data.dgov_key,
        response.data.data.dgov_verify
      )
      if (res === '验签失败') {
        return Promise.reject(new Error(res))
      }
      response.data = JSON.parse(res)
    }
    console.log(response.data)
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

export const get = (url, params) => {
  return ajax.get(url, {
    params
  })
}

export const post = (url, data) => {
  return ajax.post(url, data, {})
}